import { HttpHeaders } from '@angular/common/http';
import { inject } from '@angular/core';
import { HttpConfig, IHttpAction } from '@partners/http';
import { GLOBAL_SETTINGS, IEnvironmentSettings } from '@partners/settings';
import { ShellStore } from '@partners/state';
import { coerceString, isEmpty } from '@partners/utils';
import { IHttpContext } from '../model';
import { HTTP_CONTEXT } from '../tokens';

export class CommonHttpConfig extends HttpConfig {
  private _shellStore = inject(ShellStore);

  get environment(): IEnvironmentSettings {
    const { environment } = this._globalSettings;
    return environment;
  }
  get rootEndpoint(): string {
    return this.environment.rootEndpoint;
  }
  get apiUrl(): string {
    return this.environment.apiUrl;
  }
  get trackerUrl(): string {
    return this.environment.trackerUrl;
  }
  get useProxy(): boolean {
    return this.environment.isProxy;
  }

  get httpHeaders(): HttpHeaders {
    return (
      new HttpHeaders()
        .set('Access-Control-Allow-Headers', 'Content-Type')
        .set('Access-Control-Allow-Methods', 'GET, PUT, POST, DELETE, HEAD, OPTIONS')
        .set('Content-Type', 'application/json; charset=utf-8')
        // .set('Access-Control-Allow-Origin', '*')
        .set('Cache-Control', 'no-store, no-cache, max-age=0')
        .set('Accept', 'application/json')
    );
  }

  override buildRootEndpoint(): string {
    return this.rootEndpoint;
  }

  override buildRequestEndpoint(action: IHttpAction): URL {
    const { endpoint, options } = { ...action };

    let urlModifier;

    const requestContext = options?.context?.get<IHttpContext>(HTTP_CONTEXT);

    if (options?.context) {
      urlModifier = requestContext?.urlModifiers;
    }

    const rootEndpoint = this.buildRootEndpoint();
    const processKey = coerceString(this._shellStore.processId$$());

    const { apiUrl, isProxy, isMockMode,  } = this.environment;

    let baseUrl: string;

    if (urlModifier?.overrideUrl) {
      baseUrl = urlModifier?.overrideUrl;
    } else {
      baseUrl = apiUrl;
    }

    let urlBuilder = `${rootEndpoint}`;

    if (isMockMode || urlModifier?.overrideUrl) {
      urlBuilder = `${baseUrl}/${endpoint}`;
    } else {
      if (!urlModifier?.omitProcess && !isEmpty(processKey)) {
        urlBuilder += `/${processKey}`;
      }

      urlBuilder += `/${endpoint}`;

      urlBuilder = isProxy ? `${urlBuilder}` : `${rootEndpoint}/${urlBuilder}`;

      urlBuilder = `${baseUrl}/${urlBuilder}`;
    }

    // Console.logInfo(`http request url: ${urlBuilder}`);

    return new URL(urlBuilder);
  }

  private readonly _globalSettings = inject(GLOBAL_SETTINGS);

  constructor() {
    super();
  }
}
